import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

/**
 * TEZY2-4188: Data shape for the cancel reason dialog.
 */
export interface CancelReasonDialogData {
  title?: string;
  message?: string;
  reasonLabel?: string;
  reasonPlaceholder?: string;
  reasonRequired?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Optional RANP warning message — displayed as an amber banner above the reason input */
  ranpWarning?: string;
}

/**
 * TEZY2-4188: Result returned on confirmation.
 */
export interface CancelReasonDialogResult {
  reason: string;
}

/**
 * TEZY2-4188: Minimal MatDialog component that mirrors Fuse confirmation styling
 * but adds a textarea for cancellation reason.
 * Returns { reason: string } on confirm, or null on dismiss/cancel.
 */
@Component({
  selector: 'app-cancel-reason-dialog',
  templateUrl: './cancel-reason-dialog.component.html',
  styles: [
    `
      .cancel-reason-dialog-panel {
        @screen md {
          @apply w-128;
        }

        .mat-dialog-container {
          padding: 0 !important;
        }
      }
    `
  ],
  encapsulation: ViewEncapsulation.None
})
export class CancelReasonDialogComponent {
  reasonControl: FormControl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CancelReasonDialogData,
    public dialogRef: MatDialogRef<CancelReasonDialogComponent>
  ) {
    this.reasonControl = new FormControl(
      '',
      data?.reasonRequired ? [Validators.required] : []
    );
  }

  onConfirm(): void {
    if (this.reasonControl.invalid) {
      this.reasonControl.markAsTouched();
      return;
    }
    const result: CancelReasonDialogResult = {
      reason: this.reasonControl.value?.trim() || ''
    };
    this.dialogRef.close(result);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
